import React, { useState, useEffect } from "react";
import HamburgerMenu from "../components/HamburgerMenu/HamburgerMenu";
import { useAppContext } from '../context/AppContext';
import profileService from "../Services/ProfileService";
import Swal from "sweetalert2";
import Footer from "../components/Footer/Footer";
import { useTranslation } from 'react-i18next';

const Profile = () => {
  const [activeTab, setActiveTab] = useState("profile");
 const { token } = useAppContext();
 const [userData, setUserData] = useState(null);
        const { t } = useTranslation();

 const [updateData, setUpdateData] = useState({
    isimsoyisim: "",
    email: "",
    tel: "",
    yoksisid: "",
    fakulte: "",
    bolum: "",
    temelalan: "",
  });

 useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await profileService.getUserDetails(token);
        if (data.result) {
          setUserData(data.data);
          setUpdateData({
            isimsoyisim: data.data.isim_soyisim || "",
            email: data.data.email || "",
            tel: data.data.tel || "",
            yoksisid: data.data.yoksis_id || "",
            fakulte: data.data.fakulte_ismi || "",
            bolum: data.data.bolum_ismi || "",
            temelalan: data.data.temelalan || "",
          });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [token]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUpdateData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      };
    
      const handleProfileUpdate = async (e) => {
        e.preventDefault();
        try {
          const response = await profileService.updateUserDetails(updateData, token);
          if (response.result) {
            Swal.fire({
                icon: "success",
                title: "Başarılı!",
                text: response.status || "Profil başarıyla güncellendi!",
              });
            setUserData(response.data);
          } else {
            Swal.fire({
                icon: "error",
                title: "Hata!",
                text: response.status,
              });
          }
        } catch (error) {
          console.error("Error updating profile:", error);
          Swal.fire({
            icon: "error",
            title: "Hata!",
            text: error.response.data.status,
          });
          console.error("Error fetching user data:", error);
        
        }
      };

      const [passwordData, setPasswordData] = useState({
        currentpassword: "",
        newpassword: "",
        confirmPassword: "",
      });
      
      
      const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      };

      const handleChangePasswordSubmit = async (e) => {
        e.preventDefault();
      
        if (passwordData.newpassword !== passwordData.confirmPassword) {
          Swal.fire({
            icon: "error",
            title: "Hata!",
            text: "Yeni şifre ve şifre tekrarı uyuşmuyor.",
          });
          return;
        }
      
        try {
          const response = await profileService.changeUserPassword(passwordData, token);
          if (response.result) {
            Swal.fire({
              icon: "success",
              title: "Başarılı!",
              text: response.status || "Şifre başarıyla değiştirildi!",
            });
            setPasswordData({
              currentpassword: "",
              newpassword: "",
              confirmPassword: "",
            }); 
          } else {
            Swal.fire({
              icon: "error",
              title: "Hata!",
              text: response.status || "Şifre değiştirme sırasında bir hata oluştu.",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Hata!",
            text: error.response?.data?.status || "Şifre değiştirme sırasında bir hata oluştu.",
          });
        }
      };
      
      

  return (
    <main className="main-content bg-gray-100 min-h-screen mt-5" style={{marginTop:"5rem"}}>

      <div className="absolute top-0 left-0 p-4">
        <HamburgerMenu />
      </div>

      <div className="container mx-auto ">

        <div className="bg-white shadow-md rounded-md">
        <div className="flex">

  <div className="w-1/4  p-4" style={{borderRight:"3px solid rgb(60, 79, 88)", backgroundColor:"rgb(60, 79, 88)" , color:"white" }}>
  <button
  onClick={() => setActiveTab("profile")}
  className={`w-full py-2 text-left ${
    activeTab === "profile"
      ? "text-white"
      : "text-white hover:bg-white-100"
  }`}
  style={
    activeTab === "profile"
      ? { backgroundColor: "rgba(255, 255, 255,.8)", color:"rgb(60, 79, 88)", paddingLeft:"10px", fontWeight:"bold"  }
      : { paddingLeft:"10px"  }
  }
>
{t('Profilim')}
</button>

    <button
      onClick={() => setActiveTab("update-profile")}
      className={`w-full py-2 text-left ${
        activeTab === "update-profile"
          ? "bg-blue-500 text-white"
          : "text-white hover:bg-white-100"
      }`}
      style={
        activeTab === "update-profile"
          ? { backgroundColor: "rgba(255, 255, 255,.8)", color:"rgb(60, 79, 88)", paddingLeft:"10px", fontWeight:"bold"  }
          : { paddingLeft:"10px"  }
      }
    >
      {t('Profili Güncelle')}
    </button>
    <button
      onClick={() => setActiveTab("change-password")}
      className={`w-full py-2 text-left ${
        activeTab === "change-password"
          ? "bg-blue-500 text-white"
          : "text-white hover:bg-white-100"
      }`}
      style={
        activeTab === "change-password"
          ? { backgroundColor: "rgba(255, 255, 255,.8)", color:"rgb(60, 79, 88)", paddingLeft:"10px", fontWeight:"bold"  }
          : { paddingLeft:"10px"  }
      }
    >
       {t('Şifre Değiştir')}
    </button>
  </div>
          
          <div className="w-3/4 bg-white p-6">
            {activeTab === "profile" && (
       
  <ul className="space-y-4">
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('Ad Soyad')}:</span> &nbsp;
      <span >{userData?.isim_soyisim || "-"}</span>
    </li>
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('E-posta')}:</span>&nbsp;
      <span >{userData?.email || "-"}</span>
    </li>
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('Kurumsal E-posta')}:</span>&nbsp;
      <span >{userData?.kurumsal_email || "-"}</span>
    </li>
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('Telefon')}:</span>&nbsp;
      <span >{userData?.tel || "-"}</span>
    </li>
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('Fakülte')}:</span>&nbsp;
      <span >{userData?.fakulte_ismi || "-"}</span>
    </li>
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('Bölüm')}:</span>&nbsp;
      <span >{userData?.bolum_ismi || "-"}</span>
    </li>
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('Yöksis')}:</span>&nbsp;
      <span >{userData?.yoksis_id || "-"}</span>
    </li>
    <li className="flex border-b pb-3 mb-3">
      <span className="font-bold" style={{color:"rgb(60, 79, 88)"}}>{t('Temel Alanı')}:</span>&nbsp;
      <span >{userData?.temelalan || "-"}</span>
    </li>
  </ul>

           
            )}
       {activeTab === "update-profile" && (
  <form onSubmit={handleProfileUpdate}>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-bold mb-1 text-left" style={{color:"rgb(60, 79, 88)"}}>
        {t('Ad Soyad')}
        </label>
        <input
          type="text"
          name="isimsoyisim"
          value={updateData.isimsoyisim}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
        />
      </div>
      <div>
        <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
        {t('E-posta')}
        </label>
        <input
          type="email"
          name="email"
          value={updateData.email}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
        />
      </div>
      <div>
        <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
        {t('Telefon')}
        </label>
        <input
          type="text"
          name="tel"
          value={updateData.tel}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
        />
      </div>
      <div>
        <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
        {t('Yöksis ID')}
        </label>
        <input
          type="text"
          name="yoksisid"
          value={updateData.yoksisid}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
        />
      </div>
      <div>
        <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
        {t('Fakülte')}
        </label>
        <input
          type="text"
          name="fakulte"
          value={updateData.fakulte}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
        />
      </div>
      <div>
        <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
        {t('Bölüm')}
        </label>
        <input
          type="text"
          name="bolum"
          value={updateData.bolum}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
        />
      </div>
      <div className="col-span-2">
        <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
        {t('Temel Alan')}
        </label>
        <input
          type="text"
          name="temelalan"
          value={updateData.temelalan}
          onChange={handleInputChange}
          className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
        />
      </div>
    </div>
    <button
      type="submit"
      className="mt-6 bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600" style={{backgroundColor:"#3c4f58"}}
    >
      {t('Güncelle')}
    </button>
  </form>
)}

{activeTab === "change-password" && (
    <form onSubmit={handleChangePasswordSubmit}>
  <div className="mb-4">
  <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
  {t('Mevcut Şifre')}
    </label>
    <input
      type="password"
      name="currentpassword"
      value={passwordData.currentpassword}
      onChange={handlePasswordChange}
      className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
      required
    />
  </div>
  <div className="mb-4">
  <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
  {t('Yeni Şifre')}
    </label>
    <input
      type="password"
      name="newpassword"
      value={passwordData.newpassword}
      onChange={handlePasswordChange}
      className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
      required
    />
  </div>
  <div className="mb-4">
  <label className="block text-sm font-bold mb-1 text-left"  style={{color:"rgb(60, 79, 88)"}}>
  {t('Yeni Şifre Tekrar')}
    </label>
    <input
      type="password"
      name="confirmPassword"
      value={passwordData.confirmPassword}
      onChange={handlePasswordChange}
      className="w-full px-4 py-2 border rounded-md focus:ring focus:ring-blue-300"
      required
    />
  </div>
  <button
    type="submit"
    className="mt-6 bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600"  style={{backgroundColor:"#3c4f58"}}
  >
    {t('Şifreyi Güncelle')}
  </button>
</form>

)}

          </div>
          </div>
        </div>
      </div>
      <Footer/>
    </main>
  );
};

export default Profile;
